const seaBg = document.getElementsByClassName('js-bg')[0];
//vanilla variables for resizing 
const w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth=w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight=w.innerHeight||e.clientHeight||g.clientHeight;

(function(){
	
	
	resizeWindow();
	window.addEventListener('resize', function(){
		resizeWindow();
	});

	//burger click
	document.getElementsByClassName('js-burger')[0].addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.classList.add('open');
			document.getElementsByTagName('header')[0].classList.add('open');
			document.getElementById('primary-nav').classList.add('open');
		} else {
			this.classList.remove('open');
			document.getElementsByTagName('header')[0].classList.remove('open');
			document.getElementById('primary-nav').classList.remove('open');
		}
	});
	
	
	if(!document.getElementById('home')){
		if(windowWidth > 750){
			document.getElementsByTagName('header')[0].classList.add('go');
			document.getElementsByTagName('footer')[0].classList.add('go');
		} else {
			document.getElementsByTagName('header')[0].classList.add('default');
			document.getElementsByTagName('footer')[0].classList.add('default');
		}
		
	} else {
		//fish click event
		if(windowWidth > 1090){
			document.getElementsByClassName('js-logo')[0].addEventListener('mouseenter', function(){
				if(!document.getElementsByClassName('js-main-container')[0].classList.contains('go')){
					document.getElementsByClassName('js-main-container')[0].classList.add('go');
				}
				//adding header and footer state go
				setTimeout(function(){
					document.getElementsByTagName('header')[0].classList.add('go');
					document.getElementsByTagName('footer')[0].classList.add('go');
					document.getElementsByClassName('fish')[0].classList.add('arrived');
				}, 3500);
			});
		} else {
			document.getElementsByClassName('js-logo')[0].addEventListener('click', function(){
				if(!document.getElementsByClassName('js-main-container')[0].classList.contains('go')){
					document.getElementsByClassName('js-main-container')[0].classList.add('go');
				}
				//adding header and footer state go
				setTimeout(function(){
					document.getElementsByTagName('header')[0].classList.add('go');
					document.getElementsByTagName('footer')[0].classList.add('go');
					document.getElementsByClassName('fish')[0].classList.add('arrived');
				}, 3500);
			});
		}

		//fish go after 3 secs
		setTimeout(function(){
			if(!document.getElementsByClassName('js-main-container')[0].classList.contains('go')){
				document.getElementsByClassName('js-main-container')[0].classList.add('go');
			}
			//adding header and footer state go
			setTimeout(function(){
				document.getElementsByTagName('header')[0].classList.add('go');
				document.getElementsByTagName('footer')[0].classList.add('go');
				document.getElementsByClassName('fish')[0].classList.add('arrived');
			}, 3500);
		}, 3000);

	}
	

}());

function resizeWindow(){
	//set bg height and transformY
	if(seaBg !== undefined){
		if(windowWidth > 700){
			seaBg.setAttribute('style','height:'+ (windowWidth * 2.25) +'px; transform: translateY(-'+ ((windowWidth * 2.25) -  windowHeight)+'px)');
		} else {
			seaBg.setAttribute('style','height:4000px; transform: translateY(-'+ (4000 -  windowHeight)+'px)');
		}
		
	}
	
}
function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	
}